import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';

// A page with a `title` (and `icon`) also becomes a sidebar nav item
// (`page:agents`), which the custom Sidebar renders via `nav.rest()`.
const agentsIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="11" width="18" height="10" rx="2" />
    <circle cx="12" cy="5" r="2" />
    <path d="M12 7v4M8 16h.01M16 16h.01" />
  </svg>
);

export const page = PageBlueprint.make({
  params: {
    path: '/agents',
    title: 'Agents',
    icon: agentsIcon,
    routeRef: rootRouteRef,
    loader: () => import('./components/AgentsPage').then(m => <m.AgentsPage />),
  },
});

export const agentsPlugin = createFrontendPlugin({
  pluginId: 'agents',
  extensions: [page],
  routes: {
    root: rootRouteRef,
  },
});
